import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const MlsProviderFranchiseProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const listRecords = useCallback(async (props) => {
        await execute({ scope: 'list', url: `Franchise/GetByMls/${props.mlsProviderId}`, method: 'GET', secure: true });
    }, [execute]);  

    const value = { listRecords, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useMlsProviderFranchiseStore = () => React.useContext(Context);
